import script from "./AdminCustomPages.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminCustomPages.vue?vue&type=script&setup=true&lang=js"

import "./AdminCustomPages.vue?vue&type=style&index=0&id=4e8c5ce0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e8c5ce0"]])

export default __exports__